export default {
    title: "報價車訂單",
    search1: "開始時間：",
    search2: "結束時間：",
    search3: "開始時間",
    search4: "結束時間",
    table1: "訂單號",
    table2: "日期",
    table3: "操作用戶",
    table4: "部門",
    table5: "狀態",
    status1: "未確認",
    status2: "已報價",
    table6: "商品詳情",
    table7: "金額",
    table8: "數量",
    table9: "單位",
    table10: "備註",
    table11: "賣家留言",

    delAllBtn: "取消報價",
    orderNumber: "訂單號：",
    orderStatus: "訂單狀態：",
    total1: "共",
    total2: "件商品",
    total3: "總計：",
    addCart: "加入購物車",
    errmsg: "商品中存在非公司商品，請聯繫管理員",
    succmsg: "添加購物車成功！",
}